module.exports = __webpack_public_path__ + "img/54.983599c6.jpg";